import { Box, Card, Footer, Header, Main, Page, PageContent, PageHeader } from "grommet"
import { SettingsBox } from "./SettingsBox"
import { OverlayPreviewCard } from "./OverlayPreviewCard"
import { OverlayLinkCard } from "./OverlayLinkCard"
import SettingsContextProvider from "./SettingsContextProvider"

export const PageLayout = () => {
    return (
        <Page>
            <PageContent>
                <SettingsContextProvider>
                    <Box direction="row" gap={'medium'} margin={{ top: 'medium', bottom: 'medium' }}>
                        <Box basis="60%">
                            <OverlayPreviewCard />
                        </Box>
                        <Box basis="40%" gap={'medium'}>
                            <SettingsBox />
                            <OverlayLinkCard />
                        </Box>
                    </Box>
                </SettingsContextProvider>
            </PageContent>
        </Page>
    )
}